import { Button, LogoIcon } from '@repo/atomic-components';
import { LoginTemplate } from '@/ui/templates';
import { useNavigate } from 'react-router';
import { getRedirectPath } from '@/api/core/navigationMiddleware';

export const LoginPage = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    // Get the stored redirect path from sessionStorage
    const redirectEndpoint = getRedirectPath();

    // Navigate to login redirect with the redirectEndpoint query param if it exists
    if (redirectEndpoint) {
      navigate(`/login/redirect?redirectEndpoint=${encodeURIComponent(redirectEndpoint)}`, { relative: 'path' });
    } else {
      navigate('/login/redirect', { relative: 'path' });
    }
  };

  return (
    <LoginTemplate>
      <div className="flex w-[340px] flex-col items-center justify-center">
        <div className="scale-200">
          <LogoIcon />
        </div>
        <p className="text-fletchers-black-900 mt-4 text-[20px]/[32px] font-[400]">
          Sign in to <span className="text-[20px]/[32px] font-[600]">MeRMAIDD</span>
        </p>

        <span className="text-fletchers-gray-200 mt-1 text-[16px]/[20px] font-[400]">Using your credentials</span>

        <Button className="mt-30 w-full justify-center" size="large" onClick={handleClick}>
          Log in with Microsoft
        </Button>
      </div>
    </LoginTemplate>
  );
};
